/**
 * Uses Swiper package to create a carousel for product media
 * More info: https://swiperjs.com/
 */
class ProductMedia extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      slider: '[data-slider]',
      thumbs: '[data-thumbs]',
      mediaItem: '[data-media-id]',
    };
    this.selectedMediaIndex =
      Number(
        this.querySelector(this.selectors.slider).querySelector(
          '[data-selected]',
        )?.dataset.index,
      ) || 0;
    this.settings = {
      elements: {
        slider: this.querySelector(this.selectors.slider),
        thumbs: this.querySelector(this.selectors.thumbs),
      },
      instances: {
        slider: null,
        thumbs: null,
      },
      options: {
        slider: {
          initialSlide: this.selectedMediaIndex,
          spaceBetween: 20,
          watchOverflow: true,
          autoHeight: true,
          pagination: {
            el: this.querySelector('.swiper-pagination'),
            dynamicBullets: true,
            clickable: true
          },
          navigation: {
            prevEl: this.querySelector('.swiper-button-prev'),
            nextEl: this.querySelector('.swiper-button-next'),
          }
        },
        thumbs: {
          initialSlide: this.selectedMediaIndex,
          slidesPerView: 5,
          spaceBetween: 10,
          centerInsufficientSlides: true,
          navigation: {
            prevEl: this.querySelector('.swiper-arrow--prev'),
            nextEl: this.querySelector('.swiper-arrow--next'),
          },
          breakpoints: {
            750: {
              spaceBetween: 16
            }
          }
        },
      },
    };
  }

  connectedCallback() {
    this.init();

    document.addEventListener('alexa:start-mobile-zoom', event => {
      this.settings.instances.slider.allowTouchMove = false;
    });

    document.addEventListener('alexa:end-mobile-zoom', event => {
      this.settings.instances.slider.allowTouchMove = true;
    });

    this.settings.instances.slider.on('slideChange', () => {
      const activeSlideIndex = this.settings.instances.slider.realIndex;
      const activeSlide = this.settings.instances.slider.slides[activeSlideIndex];

      window.pauseAllMedia();

      this.playMedia(activeSlide);

      // Check if the active slide is within the first two or last two slides
      if (activeSlideIndex <= 1) {
        // Adjust the left position of the pagination items to 0
        this.settings.elements.slider.querySelectorAll('.swiper-pagination-bullet').forEach((dot) => {dot.style.left = 0});
      }
    });
  }

  init() {
    if (!this.settings.elements.slider || !this.settings.elements.thumbs)
      return;

    // Check if the number of slides is more than 5 to determine dynamicBullets
    const numberOfSlides = this.settings.elements.slider.querySelectorAll('.swiper-slide').length;
    
    if (numberOfSlides > 5) {
      this.settings.options.slider.pagination.dynamicBullets = true;
    } else {
      this.settings.options.slider.pagination.dynamicBullets = false;
    }

    this.settings.instances.thumbs = new Swiper(
      this.settings.elements.thumbs,
      this.settings.options.thumbs,
    );
    this.settings.options.slider.thumbs = {
      swiper: this.settings.instances.thumbs,
    };

    this.settings.instances.slider = new Swiper(
      this.settings.elements.slider,
      this.settings.options.slider,
    );
  }

  playMedia(activeSlide) {
    const deferredMedia = activeSlide.querySelector('.deferred-media');
    if (deferredMedia && !deferredMedia.hasAttribute('loaded')) {
      deferredMedia.loadContent(false);
    } else {
      activeSlide.querySelectorAll(".js-youtube").forEach((video) => {
        video.contentWindow.postMessage(
          '{"event":"command","func":"' + "playVideo" + '","args":""}',
          "*"
        );
      });
      activeSlide.querySelectorAll(".js-vimeo").forEach((video) => {
        video.contentWindow.postMessage('{"method":"play"}', "*");
      });
      activeSlide.querySelectorAll("video").forEach((video) => video.play());
      activeSlide.querySelectorAll("product-model").forEach((model) => {
        if (model.modelViewerUI) model.modelViewerUI.play();
      });
    }
  }

  setActiveMedia(id) {
    const mediaFound = Array.from(
      this.querySelectorAll(this.selectors.mediaItem),
    ).find((media) => Number(media.dataset.mediaId) === id);
    if (!mediaFound) return;
    this.settings.instances.slider.slideTo(Number(mediaFound.dataset.index));
  }
}

customElements.define('product-media', ProductMedia);
